import type { IFormsTemplate, IFormTemplateKey } from '@commenda/api';

export interface FormTemplateOption {
  label: string;
  value: string;
}

/** Pure lookups for the human form step panel: which form ids are live, and the dropdown's options. */
export class HumanFormStepHelper {
  static isLiveFormId(
    keys: readonly IFormTemplateKey[],
    formId: string | undefined
  ): boolean {
    return (
      formId !== undefined &&
      formId !== '' &&
      keys.some((key) => key.liveFormId === formId)
    );
  }

  /** The form the key points at today; null when the key is unknown here or has no live form. */
  static findLiveFormIdForKey(
    keys: readonly IFormTemplateKey[],
    templateKey: string | null | undefined
  ): string | null {
    if (templateKey == null || templateKey === '') return null;
    return keys.find((key) => key.key === templateKey)?.liveFormId ?? null;
  }

  /** One option per live key. A superseded form the step still points at is appended under its own
   * name, so the combobox shows what is selected instead of an empty field. */
  static buildFormTemplateOptions(
    keys: readonly IFormTemplateKey[],
    supersededTemplate: IFormsTemplate | null
  ): FormTemplateOption[] {
    const liveOptions = keys.flatMap((key) =>
      key.liveFormId === null
        ? []
        : [{ label: key.name || key.key, value: key.liveFormId }]
    );
    if (
      supersededTemplate === null ||
      liveOptions.some((option) => option.value === supersededTemplate.id)
    ) {
      return liveOptions;
    }
    return [
      ...liveOptions,
      {
        label: `${supersededTemplate.name} (v${supersededTemplate.version})`,
        value: supersededTemplate.id,
      },
    ];
  }
}
